import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AddPLayer from '../../../components/AddPLayer/AddPLayer';
import { StyledButton } from '../../../components/AddPLayer/AddPLayer.styles';
import { selectUser } from '../../../app/features/user/userSlice';
import { PROFILE_SUBSCRIPTION } from '../../../router/route-path';
import { ProfileTitle } from '../Profile.styles';
import { FlexSpace, MyPlayersWrap, UpgradeBanner, UpgradeCopy, UpgradeSubtitle, UpgradeTitle } from './MyPlayers.styles';
import PlayerList from './components/PlayerList';

const MyPlayers = () => {
	const navigate = useNavigate();
	const { userInfo } = useSelector(selectUser);
	const isFreeUser = userInfo?.role === 'Free';

	return (
		<MyPlayersWrap>
			{isFreeUser && (
				<UpgradeBanner>
					<UpgradeCopy>
						<UpgradeTitle>Upgrade to Add Players</UpgradeTitle>
						<UpgradeSubtitle>Player creation is not available on the Free plan.</UpgradeSubtitle>
					</UpgradeCopy>
					<StyledButton type="button" onClick={() => navigate(PROFILE_SUBSCRIPTION)}>
						Upgrade Now
					</StyledButton>
				</UpgradeBanner>
			)}
			<FlexSpace>
				<ProfileTitle>My Players</ProfileTitle>
				{!isFreeUser && <AddPLayer />}
			</FlexSpace>
			<PlayerList />
		</MyPlayersWrap>
	);
};

export default MyPlayers;
